<template>
  <ModalDialog
    header-text="Ingredient Application Form"
    contentClass="application-modal-content"
    :canBeClosed="!formSubmitting"
    @closeModal="closeModal"
    open
  >
    <template v-slot:content>
      <IngredientApplicationForm
        :plants="plants"
        :ukdMode="ukdMode"
        @closeForm="onFormClosed"
        @submittingChanged="(value: boolean) => (formSubmitting = value)"
      />
    </template>
  </ModalDialog>
</template>

<script setup lang="ts">
import type { IdAndName } from "@/Domain/IdAndName";
import ModalDialog from "@/shared/ui/modal/ModalDialog.vue";
import { ref } from "vue";
import { useNotificationStore } from "@/stores/useNotificationStore";
import { NotificationTypeEnum } from "@/Domain/NotificationTypeEnum";
import IngredientApplicationForm from "./IngredientApplicationForm.vue";

const notificationStore = useNotificationStore();

defineProps<{
  plants: IdAndName[];
  ukdMode?: boolean;
}>();

const emit = defineEmits<{
  (e: "closeModal"): void;
}>();

const formSubmitting = ref(false);

const onFormClosed = () => {
  emit("closeModal");
};

const closeModal = function (closed: boolean) {
  if (formSubmitting.value || !closed) {
    notificationStore.notify({
      type: NotificationTypeEnum.info,
      message: "Please wait while ingredients are being added to the cart",
      duration: 5000,
    });
    return;
  }
  emit("closeModal");
};
</script>

<style lang="scss">
.application-modal-content {
  max-width: 700px;
  padding: 2rem;
  margin: 0 -20px;
}
</style>
